import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { getCourses } from "../../../helper/apicalls/course";
import GlobalLoader from "../../common/GlobalLoader";
import "./../../../styles/admin/questionBank.scss";
import openFolder from "../../../assets/png/openFolderIcon.png";

const QuestionBankCourses = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isInstitution =
    location.pathname.startsWith("/institution") ||
    location.pathname.startsWith("/teacher");
  const { setHeaderName } = useOutletContext();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const basePath = location.pathname.startsWith("/institution")
    ? "/institution/question_banks"
    : location.pathname.startsWith("/teacher")
    ? "/teacher/question_banks"
    : "/admin/question-bank";

  const fetchCourses = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCourses();
      let normalized = [];
      if (Array.isArray(data)) {
        if (isInstitution) {
          normalized = data.flatMap((item) => item?.course || []);
        } else {
          normalized = data;
        }
      }

      setCourses(normalized);
    } catch (err) {
      console.error("Error fetching courses for Question Bank:", err);
      setError("Failed to load courses");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCourseClick = (course) => {
    if (!course?.key) return;
    navigate(`${basePath}/course/${course.key}`);
  };

  useEffect(() => {
    setHeaderName("Question Bank - Courses");
    fetchCourses();
  }, [setHeaderName]);

  return (
    <div className="question-bank-container">
      <GlobalLoader visible={loading} text="Loading..." />
      <div className="qb-card">
        <div className="qb-card-header">
          <span>Courses</span>
        </div>
        <div className="folder-grid">
          {!loading &&
            !error &&
            courses?.map((course) => (
              <div
                key={course.id || course.key}
                className="folder-item"
                onClick={() => handleCourseClick(course)}
              >
                <div className="folder-icon">
                  <img
                    src={openFolder}
                    alt="openFolder"
                    style={{ width: "75px", height: "75px" }}
                  />
                </div>
                <div className="folder-name">{course.name}</div>
              </div>
            ))}
        </div>
        {error && <div className="qb-error">{error}</div>}
      </div>
    </div>
  );
};

export default QuestionBankCourses;
